<template>
  <common-create :baseId="105" />
</template>

<script>

import CommonCreate from './CommonCreate.vue'

export default {
  name: "CreateManufacturer",
  data() {
    return {}
  },
  components: {
    CommonCreate
  },
  methods: {},
  created() { },
};
</script>